import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  loaded: false
};

export type NiasNavbarState = Readonly<typeof initialState>;

export const NiasNavbarSlice = createSlice({
  name: 'niasNavbarSlice',
  initialState: initialState as NiasNavbarState,
  reducers: {
    setLoaded(state, action) {
      return {
        ...state,
        loaded: action.payload,
      }
    },
  },
});

export const { setLoaded } = NiasNavbarSlice.actions;
export default NiasNavbarSlice.reducer;
